import { createContext, ReactNode, useContext } from 'react'

export type CdfAnalyticsSendGate = () => boolean | Promise<boolean>

const CdfAnalyticsSendGateContext = createContext<CdfAnalyticsSendGate | undefined>(undefined)

export const useCdfAnalyticsSendGate = (): CdfAnalyticsSendGate | undefined => useContext(CdfAnalyticsSendGateContext)

export const CdfAnalyticsSendGateProvider = ({
  children,
  sendGate,
}: {
  children: ReactNode
  sendGate?: CdfAnalyticsSendGate
}) => <CdfAnalyticsSendGateContext.Provider value={sendGate}>{children}</CdfAnalyticsSendGateContext.Provider>
